import React, { useEffect, useState } from "react";
import ShieldEmblemFill from "../../../icons/ShieldEmblemFill.svg";

const FocusBadge = ({ icon, progress, delay }) => {
  const radius = 42;
  const strokeWidth = 18;
  const circumference = 2 * Math.PI * radius;

  const [animatedProgress, setAnimatedProgress] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAnimatedProgress(progress);
    }, delay); // staggered
    return () => clearTimeout(timeout);
  }, [progress, delay]);

  const progressOffset =
    circumference - (animatedProgress / 100) * circumference;

  return (
    <div className="flex flex-col items-center">
      <div className="relative w-28 h-28">
        <svg
          className="absolute top-0 left-0"
          width="112"
          height="112"
          viewBox="0 0 120 120"
        >
          <circle
            cx="60"
            cy="60"
            r={radius}
            stroke="#60A5FA"
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={progressOffset}
            strokeLinecap="round"
            transform="rotate(0 60 60)" // 3 o'clock start
            style={{
              transition: "stroke-dashoffset 1.2s ease-out",
            }}
          />
        </svg>

        {/* Center shield */}
        <div className="absolute inset-0 flex items-center justify-center translate-y-[1px]">
          <div className="w-16 h-16 bg-gradient-to-b from-indigo-950 to-blue-700 rounded-full flex items-center justify-center shadow-lg">
            <img
              src={icon}
              alt="Focus Badge"
              className="w-10 h-10 object-contain"
            />
          </div>
        </div>
      </div>

      {/* % Label */}
      <span className="mt-3 text-sm font-semibold text-gray-700">
        {progress}%
      </span>
    </div>
  );
};

const FocusBadges = ({ focus = [] }) => {
  const badges = focus.length
    ? focus
    : [
        { icon: ShieldEmblemFill, progress: 83 },
        { icon: ShieldEmblemFill, progress: 70 },
      ];

  return (
    <div className="flex justify-center items-center gap-16 mt-6">
      {badges.map((badge, i) => (
        <FocusBadge
          key={i}
          icon={badge.icon}
          progress={badge.progress}
          delay={i * 300} // stagger animations
        />
      ))}
    </div>
  );
};

export default FocusBadges;
